import { Channel, } from "core/codegen/types";
import { config } from "core/utils";
export var toQueryVariables = function (userInput) { return ({
    text: userInput.text.length <= 0 ? null : userInput.text,
    channel: userInput.channel.current !== "all" ? userInput.channel.current : null,
    category: userInput.category !== "all" ? userInput.category : null,
    letter: userInput.letter.length <= 0 ? null : userInput.letter,
}); };
export var toSkipQuery = function (userInput) {
    return userInput.text.length < config.search.threshold &&
        userInput.channel.current === "all" &&
        userInput.category === "all" &&
        userInput.letter.length <= 0;
};
export var isResultsHidden = function (userInput) {
    return userInput.text.length === 0 &&
        userInput.channel.current === "all" &&
        userInput.category === "all" &&
        userInput.letter.length <= 0;
};
export var initial = {
    text: "",
    channel: {
        current: "all",
        previous: "all",
    },
    category: "all",
    letter: "",
};
export var isMoviesVisible = function (userInput) {
    return userInput.text.length <= 1 &&
        userInput.letter.length <= 0 &&
        userInput.category === "all" &&
        isMoviesChannel(userInput.channel.current);
};
var isMoviesChannel = function (channel) {
    return ["all", Channel.Vtm3, Channel.Vtm4].includes(channel);
};
